// import constants from "@/libs/constants";
import { defaultFileObj, defaultPersonObj, defaultAddressObj } from "../libs/common";
import { defineStore } from "pinia";
var _ = require('lodash');

const defaultForm = () => {
  return {
    id: null,
    coName: null,
    coNameChi: null,
    mailingAddr: defaultAddressObj(1),
    workLoc: defaultAddressObj(0),
    contact: {
      phone: null,
      fax: null
    },
    chop: defaultFileObj(),
    workLocProof: defaultFileObj(),
    nameChangeProof: defaultFileObj(),
    responPerson: defaultPersonObj(),
    coordinator: defaultPersonObj(),
    authorizedStaffs: [],
    applicant: defaultPersonObj(),
    isCoorEqResp: false,
    isSameAsWorkLoc: false,
    batchUploadKey: null,
    validated: [false, false, false, false]
  };
};

export const useRegistrationStore = defineStore("registration", {
  state: () => {
    return {
      locale: null,
      jwt: null,
      acknowledged: null,
      agreement: false,
      complete: false,
      sendEmail: false,
      form: defaultForm(),
      selectedChange: [],
      staffTabIndex: {
        current: -1,
        prev: null
      },
      authenToken: null,
      verified: false
    }
  },
  getters: {
    regJWT: state => {
      return state.jwt;
    }
  },
  actions: {
    updateRegLocale(val) {
      this.locale = val
    },
    updateRegForm(val) {
      this.form = val;
    },
    updateRegAcknowledged(val) {
      this.acknowledged = val;
    },
    updateRegAgreement(val) {
      this.agreement = val;
    },
    updateRegFormVerified(val) {
      this.verified = val;
    },
    updateAnonymousJWT(val) {
      this.jwt = val;
    },
    updateRegAppNo(val) {
      this.form.id = val;
    },
    updateRegComplete(val) {
      this.complete = val;
    },
    updateRegChangeSelected(val) {
      this.selectedChange = val;
    },
    updateRegFormDataByPath(obj) {
      let target = this.form;
      console.log(target, obj.path, obj.value)
      _.set(target, obj.path, obj.value);
    },
    updateRegStaffTabIndexCur(val) {
      this.staffTabIndex.current = val;
    },
    updateRegStaffTabIndexPrev(val) {
      this.staffTabIndex.prev = val;
    },
    updateRegModAuthenToken(val) {
      this.authenToken = val
    },
    updateRegFormBatchUploadKey(val) {
      this.form.batchUploadKey = val;
    },
    updateRegFormEmailFlag(val) {
      this.sendEmail = val;
    },
    updateRegStepValidated(obj) {
      this.form.validated[obj.index] = obj.isValidated
    },
    resetRegStepValidated() {
      this.form.validated = [false, false, false, false]
    },
    resetRegFormEmailFlag() {
      this.sendEmail = false;
    },
    resetRegFormBatchUploadKey() {
      this.form.batchUploadKey = null;
    },
    resetRegModAuthenToken() {
      this.authenToken = null;
    },
    resetRegFormVerified() {
      this.verified = false;
    },
    resetRegStaffTabIndexCur() {
      this.staffTabIndex.current = -1
    },
    resetRegStaffTabIndexPrev() {
      this.staffTabIndex.prev = null
    },
    resetRegStaffTabIndex() {
      this.staffTabIndex = {
        current: -1,
        prev: null
      }
    },
    resetRegChangeSelected() {
      this.selectedChange = [];
    },
    resetRegForm() {
      let formObj = defaultForm();
      formObj.id = this.form.id
      this.form = formObj;
    },
    resetRegState(removeJWT = true) {
      let formObj = defaultForm();
      if(removeJWT) {
        this.jwt = null;
      }
      this.agreement = false;
      this.locale = null;
      this.complete = false;
      this.form = formObj;
      this.acknowledged = null;
      this.agreement = false;
      this.verified = false;
      this.complete = false;
      this.selectedChange = [];
      this.staffTabIndex = {
        current: -1,
        prev: null
      };
      this.authenToken = null;
      this.sendEmail = false;
    },
    resetRegModState(removeJWT = true) {
      let formObj = defaultForm();
      if(removeJWT) {
        this.jwt = null;
      }
      this.agreement = false;
      this.locale = null;
      this.complete = false;
      this.form = formObj;
      this.acknowledged = null;
      this.agreement = false;
      this.verified = false;
      this.complete = false;
      this.selectedChange = [];
      this.staffTabIndex = {
        current: -1,
        prev: null
      };
      this.sendEmail = false;
    }
  },
  persist: true
});
